module.exports = __webpack_public_path__ + "static/media/edit-series.429ea20f.svg";